// import * as basicLightbox from "basiclightbox";

export default class ConsentBox {
  constructor() {
    this.state = {
      cookieTypes: {
        necessary: false,
        statistics: false,
        marketing: false,
        userAction: false,
      },
      boxDisplayed: false,
    };

    // this.modal = null;

    this.cookieName = "cookie-box";
    this.cookieMaxAge = 60 * 60 * 24 * 365;

    this.cookieBoxUriPath = "cookie-box";

    this.cookieBoxNode = null;
    this.formNode = null;
    this.acceptNode = null;
    this.declineNode = null;

    this.disclaimer = window.disclaimer;

    this.parseUrl();
    this.parseCookie();

    if (!this.getHasCookie()) {
      this.loadDefaultTag();
    } else {
      this.loadStoredTag();
    }

    this.bindDisclaimerEvents();

    this.jentisLoaded = false;
    if (window.jentis) {
      this.bindJentisEvents();
    }
  }

  bindJentisEvents() {
    // jentis code example mit this.jentisLoaded = true wenn event kommt
    if (
      typeof window.jentis !== "undefined" &&
      typeof window.jentis.consent !== "undefined" &&
      typeof window.jentis.consent.engine !== "undefined"
    ) {
      //If the engine is allready loaded, we maybe missed the events, so we want to register at the engine instead of the document.
      var oEventBaseObject = window.jentis.consent.engine;
    } else {
      //No engine allready exists, so it is safe to register at the document.
      var oEventBaseObject = document;
    }
    oEventBaseObject.addEventListener("jentis.consent.engine.init", () => {
      this.jentisLoaded = true;
    });
  }

  jentisExecute(functionToExecute) {
    if (!window.jentis) {
      return;
    }

    let functionWasExecuted = false;

    console.log("jentisExecute( " + functionToExecute.toString() + " ) - Wait for Jentis to be ready..");

    // warten bis jentis ready ist..
    const interval = setInterval(() => {
      if (!functionWasExecuted && this.jentisLoaded) {
        functionWasExecuted = true;
        console.log(
          "jentisExecute( " + functionToExecute.toString() + " ) - Executed successfully."
        );
        functionToExecute();
      }
    }, 10);

    // versuch nach 2 s abbrechen..
    setTimeout(() => {
      if (!functionWasExecuted) {
        console.log(
          "jentisExecute( " +
            functionToExecute.toString() +
            " ) - Failed: Jentis Consent Engine not loaded after 2 seconds!"
        );
      }
      clearInterval(interval);
    }, 2000);
  }

  getIsCookieBoxDisplayed() {
    return this.state.boxDisplayed;
  }

  getHasCookie() {
    return !!this.state.cookieTypes.userAction;
  }

  getUrlAndCookieStateMatch() {
    return this.getHasCookie();
  }

  checkCookieBox() {
    this.cookieBoxNode = document.getElementById("consent-box");

    if (!this.disclaimer || !this.disclaimer.getIsDisclaimerDisplayed()) {
      if (!this.getHasCookie()) {
        this.showCookieBox();
      } else {
        this.hideCookieBox();
      }
    }
  }

  parseUrl() {
    const params = new URLSearchParams(window.location.search);

    if (params.has("cookie-box-accepted")) {
      const cookieTypes = params.get("cookie-box-accepted");
      this.setCookie(
        cookieTypes.includes("n"), //necessary
        cookieTypes.includes("s"), //statistics
        cookieTypes.includes("m") //marketing
      );
    }
  }

  parseCookie() {
    const allCookies = Object.fromEntries(
      document.cookie
        .split(/; */)
        .filter((c) => c !== "")
        .map((c) => {
          const [key, v] = c.split("=", 2);
          return [key, decodeURIComponent(v)];
        })
    );

    if (typeof allCookies[this.cookieName] !== "undefined") {
      try {
        const cookie = JSON.parse(allCookies[this.cookieName]);
        this.state.cookieTypes.necessary = cookie.necessary || null;
        this.state.cookieTypes.statistics = cookie.statistics || null;
        this.state.cookieTypes.marketing = cookie.marketing || null;
        this.state.cookieTypes.userAction = cookie.userAction || null;
      } catch (e) {
        console.error("Could not parse cookieBox cookie value", e);
      }
    }
  }

  setCookie(necessary, statistics, marketing) {
    const cookieContent = JSON.stringify({
      necessary,
      statistics,
      marketing,
      userAction: true,
    });

    document.cookie = `${this.cookieName}=${cookieContent}; path=/; SameSite=strict; max-age=${this.cookieMaxAge}`;
  }

  hideCookieBox() {
    // this.modal.close();
    this.cookieBoxNode.classList.add("consent-box--hidden");
    this.state.boxDisplayed = false;
  }

  showCookieBox() {
    if (this.isSearchEngine()) {
      return;
    }

    this.cookieBoxNode.classList.remove("consent-box--hidden");
    this.state.boxDisplayed = true;

    this.initForm();

    // this.initCookieBannerModal();
    // this.modal.show();
  }

  // initCookieBannerModal() {
  //     const modal = document.querySelector(".cookie-box");
  //
  //     this.modal = basicLightbox.create(modal, {
  //         className: "basicLightbox--navigation",
  //         onShow: () => {
  //             this._scrollPosition = window.pageYOffset;
  //             document.body.classList.add("basicLightbox--enabled");
  //             document.body.style.top = `-${this._scrollPosition}px`;
  //         },
  //         onClose: () => {
  //             document.body.classList.remove("basicLightbox--enabled");
  //             document.body.style.top = null;
  //             window.scrollTo({
  //                 top: this._scrollPosition,
  //                 behavior: "instant",
  //             });
  //         },
  //     });
  // }

  getFormNodes() {
    this.formNode = this.cookieBoxNode.querySelector("form");

    this.necessaryCookies = this.formNode.querySelector("#necessary-cookies");
    this.statisticsCookies = this.formNode.querySelector("#statistics-cookies");
    this.marketingCookies = this.formNode.querySelector("#marketing-cookies");

    this.acceptNode = this.formNode.querySelector("#cookie-accept-button");
    this.declineNode = this.formNode.querySelector("#cookie-decline-button");
  }

  bindFormEvents() {
    this.acceptNode.addEventListener("click", (event) =>
      this.acceptHandler(event)
    );
    this.declineNode.addEventListener("click", (event) =>
      this.declineHandler(event)
    );
    this.formNode.addEventListener("submit", (event) => {
      event.preventDefault();
    });
    this.necessaryCookies.addEventListener("change", (event) => {
      event.preventDefault();
    });
  }

  bindEvents() {}

  acceptHandler(event) {
    event.preventDefault();

    const formValues = this.getFormValues();

    this.setCookie(true, formValues.statistics, formValues.marketing);

    this.state.cookieTypes.necessary = true;
    this.state.cookieTypes.statistics = formValues.statistics;
    this.state.cookieTypes.marketing = formValues.marketing;
    this.state.cookieTypes.userAction = true;

    this.hideCookieBox();

    this.notifyCookieBoxAccepted();

    this.loadAcceptedTag();
  }

  declineHandler(event) {
    event.preventDefault();

    this.setCookie(false, false, false);

    this.state.cookieTypes.necessary = false;
    this.state.cookieTypes.statistics = false;
    this.state.cookieTypes.marketing = false;
    this.state.cookieTypes.userAction = true;

    this.hideCookieBox();

    this.notifyCookieBoxAccepted();
  }

  getFormValues() {
    return {
      necessary: this.necessaryCookies.checked,
      statistics: this.statisticsCookies.checked,
      marketing: this.marketingCookies.checked,
    };
  }

  initForm() {
    this.getFormNodes();
    this.bindFormEvents();
  }

  notifyCookieBoxAccepted() {
    window.dispatchEvent(
      new CustomEvent("cookieBox:accepted", { state: this.state.cookieTypes })
    );
  }

  bindDisclaimerEvents() {
    window.addEventListener("disclaimer:hidden", (event) => {
      this.checkCookieBox();
    });
  }

  loadDefaultTag() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("consent", "default", {
      functionality_storage: "denied",
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      personalization_storage: "denied",
      security_storage: "denied",
      wait_for_update: 1000,
      url_passthrough: true,
      ads_data_redaction: true,
    });

    // warten bis jentis ready ist..
    this.jentisExecute(() => {
      jentis.consent.engine.DenyAll();
    });
  }

  loadAcceptedTag() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("consent", "update", {
      functionality_storage: "granted",
      analytics_storage: this.statisticsCookies.checked ? "granted" : "denied",
      ad_storage: this.marketingCookies.checked ? "granted" : "denied",
      ad_user_data: this.marketingCookies.checked ? "granted" : "denied",
      ad_personalization: this.marketingCookies.checked ? "granted" : "denied",
      personalization_storage: "granted",
      security_storage: "granted",
      wait_for_update: 1000,
      url_passthrough: true,
      ads_data_redaction: true,
    });

    if (this.statisticsCookies.checked) {
      this.jentisExecute(() => {
        jentis.consent.engine.AcceptAll();
      });
    } else {
      this.jentisExecute(() => {
        jentis.consent.engine.DenyAll();
      });
    }
  }

  loadStoredTag() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("consent", "default", {
      functionality_storage: this.state.cookieTypes.necessary
        ? "granted"
        : "denied",
      analytics_storage: this.state.cookieTypes.statistics
        ? "granted"
        : "denied",
      ad_storage: this.state.cookieTypes.marketing ? "granted" : "denied",
      ad_user_data: this.state.cookieTypes.marketing ? "granted" : "denied",
      ad_personalization: this.state.cookieTypes.marketing
        ? "granted"
        : "denied",
      personalization_storage: "granted",
      security_storage: "granted",
      wait_for_update: 1000,
      url_passthrough: true,
      ads_data_redaction: true,
    });

    if (this.state.cookieTypes.necessary) {
      this.jentisExecute(() => {
        jentis.consent.engine.AcceptAll();
      });
    } else {
      this.jentisExecute(() => {
        jentis.consent.engine.DenyAll();
      });
    }
  }

  isSearchEngine() {
    // on changes head over to head over to DistributionPackages/Bellevue.Disclaimer/Resources/Private/Fusion/Component/Disclaimer/Disclaimer.js too..
    const detectRobot = (userAgent) => {
      const robots = new RegExp(
        [
          /bot/,
          /spider/,
          /crawl/, // GENERAL TERMS
          /APIs-Google/,
          /AdsBot/,
          /Googlebot/, // GOOGLE ROBOTS
          /mediapartners/,
          /Google Favicon/,
          /FeedFetcher/,
          /Google-Read-Aloud/,
          /DuplexWeb-Google/,
          /googleweblight/,
          /bing/,
          /yandex/,
          /baidu/,
          /duckduck/,
          /yahoo/, // OTHER ENGINES
          /ecosia/,
          /ia_archiver/,
          /facebook/,
          /instagram/,
          /pinterest/,
          /reddit/, // SOCIAL MEDIA
          /slack/,
          /twitter/,
          /whatsapp/,
          /youtube/,
          /semrush/, // OTHER
          // /chrome/,                                         // OTHER
        ]
          .map((r) => r.source)
          .join("|"),
        "i"
      ); // BUILD REGEXP + "i" FLAG

      return robots.test(userAgent);
    };

    return detectRobot(navigator.userAgent);
  }
}
